
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "whats-new-in-apache-atlas-20"
    }}>{`What's new in Apache Atlas 2.0?`}</h1>
    <h2 {...{
      "id": "features"
    }}>{`Features`}</h2>
    <ul>
      <li parentName="ul">{`Soft-reference attribute implementation.`}</li>
      <li parentName="ul">{`Unique-attributes constraint at graph store-level`}</li>
      <li parentName="ul">{`Atlas Index Repair tool for Janusgraph`}</li>
      <li parentName="ul">{`Relationship notifications when new relationships are created in atlas`}</li>
      <li parentName="ul">{`Atlas Import Transform handler implementation`}</li>
    </ul>
    <h2 {...{
      "id": "updates"
    }}>{`Updates`}</h2>
    <ul>
      <li parentName="ul">{`Updated component versions to use Hadoop 3.1, Hive 3.1, HBase 2.0, Solr 7.5 and Kafka 2.0`}</li>
      <li parentName="ul">{`Updated JanusGraph version to 0.3.1`}</li>
      <li parentName="ul">{`Updated authentication to support trusted proxy`}</li>
      <li parentName="ul">{`Updated patch framework to persist typedef patches applied to atlas and handle data patches.`}</li>
      <li parentName="ul">{`Updated metrics module to collect notification metrics`}</li>
      <li parentName="ul">{`Updated Atlas Export to support incremental export of metadata.`}</li>
      <li parentName="ul">{`Notification Processing Improvements:`}
        <ul parentName="li">
          <li parentName="ul">{`Notification processing to support batch-commits`}</li>
          <li parentName="ul">{`New option in notification processing to ignore potentially incorrect hive_column_lineage`}</li>
          <li parentName="ul">{`Updated Hive hook to avoid duplicate column-lineage entities; also updated Atlas server to skip duplicate column-lineage entities`}</li>
          <li parentName="ul">{`Improved batch processing in notification handler to avoid processing of an entity multiple times`}</li>
          <li parentName="ul">{`Add option to ignore/prune metadata for temporary/staging hive tables`}</li>
          <li parentName="ul">{`Avoid unnecessary lookup when creating new relationships`}</li>
        </ul>
      </li>
      <li parentName="ul">{`UI Improvements:`}
        <ul parentName="li">
          <li parentName="ul">{`UI: Display counts besides the Type and Classification dropdown list in basic search`}</li>
          <li parentName="ul">{`UI: Display lineage information for process entities`}</li>
          <li parentName="ul">{`UI: Display entity specific icon for the lineage graph`}</li>
          <li parentName="ul">{`UI: Add relationships table inside relationships view in entity details page.`}</li>
          <li parentName="ul">{`UI: Add service-type dropdown in basic search to filter entitydef type.`}</li>
          <li parentName="ul">{`Various Bug-fixes and optimizations`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <a href="https://issues.apache.org/jira/issues/?jql=project%20%3D%20ATLAS%20AND%20status%20%3D%20Resolved%20AND%20fixVersion%20%3D%202.0.0%20ORDER%20BY%20updated%20DESC%2C%20priority%20DESC">List of JIRAs resolved in Apache Atlas 2.0.0</a>
      </li>
    </ul>
    <h2 {...{
      "id": "data-migration"
    }}>{`Data Migration`}</h2>
    <p>{`With the introduction of unique-attributes constraint at graph store changes - when atlas starts up for the first time after migration to 2.0, expect some delay during startup since unique attribute constraint will be added to existing atlas metadata.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;